
import { BookOpen, ChartBar, Headphones, Settings, TrendingUp, Users } from "lucide-react";

type FeatureCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

const FeatureCard = ({ icon, title, description }: FeatureCardProps) => {
  return (
    <div className="bg-black/60 border border-gray-700 rounded-lg p-6 backdrop-blur-md transition-all duration-300 hover:scale-[1.02] hover:shadow-xl">
      <div className="flex justify-center mb-6">
        <div className="bg-blue-100/20 rounded-full p-4">
          {icon}
        </div>
      </div>
      <h3 className="text-xl font-bold text-white mb-3 text-center">{title}</h3>
      <p className="text-gray-300 text-center">{description}</p>
    </div>
  );
};

const HowItWorks = () => {
  const features = [
    {
      icon: <ChartBar className="h-8 w-8 text-[#33C3F0]" />,
      title: "Research & Strategy",
      description: "Learn how to identify profitable token pairs and market conditions optimal for grid trading"
    },
    {
      icon: <Settings className="h-8 w-8 text-[#33C3F0]" />,
      title: "Automation Setup",
      description: "Master the configuration of grid bots that work 24/7 to capitalize on market volatility"
    },
    {
      icon: <TrendingUp className="h-8 w-8 text-[#33C3F0]" />,
      title: "Passive Income",
      description: "Build a sustainable income stream with stablecoin and native BTC yield - entirely spot-based"
    }
  ];

  const courseFeatures = [
    {
      icon: <BookOpen className="h-8 w-8 text-[#33C3F0]" />,
      title: "DeFi Deep Dive",
      description: "Understand the core concepts of Decentralized Finance and how to leverage them for yield."
    },
    {
      icon: <Headphones className="h-8 w-8 text-[#33C3F0]" />,
      title: "Expert Guidance",
      description: "Direct insights and strategies from experienced traders and DeFi practitioners."
    },
    {
      icon: <Users className="h-8 w-8 text-[#33C3F0]" />,
      title: "Community Access",
      description: "Join an exclusive community of like-minded individuals on the same journey."
    }
  ];

  return (
    <section className="bg-black py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4">How GridBot & DeFi Mastery Works</h2>
        <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
          Learn to leverage automated grid trading for consistent crypto yield
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {courseFeatures.map((feature, index) => (
            <FeatureCard 
              key={`course-${index}`}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
